import { HTMLAttributes, ReactNode } from "react";

type CardVariant = "glass" | "solid" | "hero";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  // glass (default) = frost + top sheen; solid = white surface (dense tables);
  // hero = larger radius + deeper float.
  variant?: CardVariant;
  // padded (default true) applies the standard space-5 inset; pass false to lay
  // out the inner content yourself (e.g. an edge-to-edge media card).
  padded?: boolean;
  // interactive adds the hover lift + pointer cursor (clickable cards).
  interactive?: boolean;
}

/**
 * Card — the shared frosted surface primitive (a 1:1 port of the design system's
 * `Card` / `pf-card`). Compose with a layout className for the inner content
 * (gap / flex), exactly like the design's `<Card variant="glass" className="…">`.
 * Prefix: gc-. Styles live in glassCardStyles (aggregated in libraryStyles).
 */
const Card = ({
  children,
  variant = "glass",
  padded = true,
  interactive = false,
  className = "",
  ...rest
}: CardProps) => {
  const cls = [
    "gc-card",
    `gc-card--${variant}`,
    padded ? "gc-card--pad" : "",
    interactive ? "gc-card--interactive" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
};

export default Card;
